export default __webpack_public_path__ + "static/media/line.b9c4a2c4.png";